/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type HookTuple = [
  response: vp.RetriggerWebhookResponse,
  RetriggerWebhook: (params: vp.RetriggerWebhookRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;


const usePostResendWebhook: ApiHook = ({ api }) => {
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.RetriggerWebhookRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(()=> {

    const sendRequest = async (requestParams: vp.RetriggerWebhookRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postPartnerResendWebhook(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };

  }, [shouldSendRequest])

  return [
    response,
    (requestParams: vp.RetriggerWebhookRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostResendWebhook);
